$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/list_add'
{ track } = require '@trello/analytics'

module.exports = class InlineListComposerView extends View
  className: 'js-add-list list-wrapper mod-add is-idle'

  initialize: ->
    @listenTo @model.viewState, 'change:listComposerOpen',
      @frameDebounce @renderListComposer

    @listenTo @model, 'change:limits', @render

    @listenTo @model.listList, 'add remove', @render

    @handleClickOutside = @handleClickOutside.bind(this)
    $(document).on('click', @handleClickOutside)

  remove: ->
    $(document).off('click', @handleClickOutside)
    super

  events:
    'click .js-open-add-list': 'setOpen'
    'click .js-cancel-edit': 'setClose'
    'submit': 'addList'

  handleClickOutside: (e) ->
    # We aren't interested in this event if the list composer is not open
    if !@model.viewState.get('listComposerOpen')
      return

    $target = $(event.target)
    wasClickOutside = $target.closest('.js-add-list').length == 0
    if (wasClickOutside)
      @setClose(e)

  render: ->
    isFirstList = @model.listList.length == 0

    @$el.html(
      template({
        tooManyTotalLists: @model.isOverLimit('lists', 'totalPerBoard')
        tooManyOpenLists: @model.isOverLimit('lists', 'openPerBoard')
        isFirstList: isFirstList,
      })
    )

    @renderListComposer()

    if @model.editable()
      @$el.removeClass('fade hide')

    @

  setOpen: (e) ->
    @$('.js-open-add-list').attr('tabindex', '-1')
    Util.stop(e)
    @model.viewState.set('listComposerOpen', true)
    return

  setClose: (e) ->
    @$('.js-open-add-list').removeAttr('tabindex')
    Util.stop(e)
    @model.viewState.set('listComposerOpen', false)
    return

  renderListComposer: ->
    if @model.viewState.get('listComposerOpen') &&
    !@model.isOverLimit('lists', 'totalPerBoard') &&
    !@model.isOverLimit('lists', 'openPerBoard')
      @renderOpen()
    else
      @renderClose()

  renderOpen: (e) ->
    Util.stop(e)

    @$el.removeClass('is-idle')

    @defer =>
      @$('.list-name-input').blur().focus().select()

    PopOver.hide()
    return

  renderClose: (e) ->
    Util.stop(e)
    @$el.addClass('is-idle')
    return

  addList: (e) ->
    Util.stop(e)

    $input = @$('.list-name-input')
    lists = @model.listList
    listsLength = lists.length + 1

    listName = $input.val().trim()

    if listName == ''
      $input.focus().select()
      return

    createdList = @model.listList.create(
      {
        name: listName,
        pos: @model.calcPos(listsLength),
        closed: false
      },
      {
        success: (model) =>
          track("Board View", "Add List - via Inline List Composer")
        error: =>
          @model.listList.remove(createdList)
      }
    )
    $input.val('')

    @renderOpen()

    @
